import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`

let api = {
  // 查询金额配置分页
  getYqingBasicConfigPage: `${baseUrl}/yqingBasicConfig/getPage`,

  // 添加金额配置
  addyqingBasicConfig: `${baseUrl}/yqingBasicConfig/add`,

  // 查询金额配置详情
  getYqingBasicConfigByCode: `${baseUrl}/yqingBasicConfig/getByCode`,

  // 修改金额配置
  updateyqingBasicConfig: `${baseUrl}/yqingBasicConfig/update`,

  // 删除金额配置
  deleteyqingBasicConfigByCodes: `${baseUrl}/yqingBasicConfig/deleteByCodes`,

  // 查询缴费记录分页
  getYqingPayRecordPage: `${baseUrl}/yqingPayRecord/getPage`,

  // 导出缴费记录
  exportyqingPayRecord: `${baseUrl}/yqingPayRecord/export`,

  // 查询报警记录
  getYqingAlarmRecord: `${baseUrl}/yqingAlarmRecord/getPage`,

  // 导出报警记录
  exportyqingAlarmRecord: `${baseUrl}/yqingAlarmRecord/export`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/yqingService.js